import { ColumnFilterItem } from "antd/es/table/interface";
import { useMemo } from "react";

export const useFilters = () => {
  const filters: ColumnFilterItem[] = useMemo(
    () => [
      {
        text: "Payment Receipts",
        value: 0,
      },
      {
        text: "Deposit Receipts",
        value: 1,
      },
      {
        text: "Late Notices",
        value: 2,
      },
      {
        text: "Other Mailings",
        value: 3,
      },
    ],
    []
  );

  return { filters };
};
